import { useQuery } from "@tanstack/react-query";
import apiInstance from "../../instances/apiInstance";
import { API_ENDPOINTS } from "../../../helpers/constants";
import { BulkImportResponse } from "./model";

export const useGetBulkImportQuery = (
  processType: string = "in-progress",
  categoryType?: string,
  enabled?: boolean,
) => {
  return useQuery<BulkImportResponse>({
    queryKey: ["getBulkImport", processType, categoryType],
    queryFn: async () => {
      const params: Record<string, string> = { processType };
      if (categoryType) {
        params.categoryType = categoryType;
      }

      const res = await apiInstance.get(
        API_ENDPOINTS.GET_BULK_PROCESS_BY_STATUS,
        { params },
      );

      return res.data;
    },
    enabled,
    retry: false,
  });
};
